import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "list",
  "use": "list-usage",
  "viewBox": "0 0 12 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 14\" id=\"list\"><g fill-rule=\"evenodd\"><path d=\"M0 0v14h12V4.376L7.714 0H0zm1 1h5.786v4.313H11V13H1V1zm6.786.503l2.753 2.81H7.786v-2.81z\" /><path d=\"M2.571 8h6.857V7H2.571zM2.571 5h3V4h-3zM2.571 11h6.857v-1H2.571z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id